import React from "react";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import Dialer from "../components/Dialer";
import Button from "../components/buttons/Button";
import CallButton from "../components/buttons/CallButton";
import { loadServices } from "../actions/serviceActions";
import { call } from "../actions/sipActions";
import { bindLocalStream, unBindLocalStream } from "../actions/configActions";
import "./Call.css";

/* The Call page when you can dial anyone you want */
class Call extends React.Component {
  smallScreenMode = false;
  cameraActive = false;

  startSelfViewStream() {
    this.cameraActive = true;
    var oldThis = this;
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(function(stream) {
        oldThis.props.bindLocalStream(stream);
      })
      .catch(function(err) {
        console.log("Error when trying to access camera, ", err);
      });
  }

  componentWillMount() {
    this.smallScreenMode = window.innerWidth < 992 ? true : false;
  }

  componentDidMount() {
    var el = document.getElementById("number");
    if (el !== null) {
      el.focus();
    }

    if (this.props.useVideo && !this.smallScreenMode && !this.cameraActive) {
      this.startSelfViewStream();
    }

    this.props.loadServices();
  }

  componentWillUnmount() {
    if (this.props.useVideo && !this.smallScreenMode && this.cameraActive) {
      this.props.unBindLocalStream();
    }
  }

  onDialer = c => {
    this.number.value = this.number.value + c;
  };

  onDelete = () => {
    if (this.number.value.length <= 0) return;
    this.number.value = this.number.value.substr(
      0,
      this.number.value.length - 1
    );
  };

  onCall = () => {
    if (this.number.value.length <= 0) return false;
    this.props.call(this.number.value);
  };

  getSIP = () => {
    if (this.number.value.length <= 0) return "";
    return this.number.value;
  };

  submit = e => {
    e.preventDefault();
    this.onCall();
  };

  render() {
    if (this.props.loading) {
      return <Loading />;
    }

    if (this.props.useVideo && !this.smallScreenMode && !this.cameraActive) {
      this.startSelfViewStream();
    } else if (
      !this.props.useVideo &&
      !this.smallScreenMode &&
      this.cameraActive
    ) {
      this.props.unBindLocalStream();
      this.cameraActive = false;
    }

    return (
      <div className="call-container">
        <div
          className={
            "dialer-container" +
            (this.props.videoavailable !== true ? " margin-auto" : "")
          }
        >
          <h1 id="h1id">{this.props.text("common.call")}</h1>

          <form className="call-form" onSubmit={this.submit}>
            <div className="form-row">
              <div className="col-9">
                <input
                  required={true}
                  type="text"
                  className="form-control height-100-procent"
                  id="number"
                  name="number"
                  placeholder={this.props.text("call.placeholder")}
                  ref={obj => {
                    this.number = obj;
                  }}
                  aria-label={this.props.text("call.placeholder")}
                />
              </div>
              <div className="col-3">
                <Button
                  type="button"
                  icon="backspace"
                  className="width-100-procent"
                  onClick={() => this.onDelete()}
                  ariaLabelText={this.props.text("aria.back_button")}
                />
              </div>
            </div>
          </form>

          <Dialer
            onClick={obj => {
              this.onDialer(obj);
            }}
            inCall={false}
          />

          <div className="text-align-center dialer-call">
            <CallButton
              size="large"
              onClick={() => {
                this.onCall();
              }}
            />
          </div>
        </div>

        {this.props.useVideo && (
          <video
            id="local-video"
            className="before-call-video"
            aria-label={this.props.text("aria.selfview")}
          >
            <track kind="captions" src="noCaptions.vtt" />
            <track
              kind="descriptions"
              src="noDescription.vtt"
              srcLang="en"
              label="english_description"
            ></track>
          </video>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    services: state.service.services,
    useVideo: state.config.mode.video && state.setting.user.WEB_VIDEO === "true",
    loading: false,
    text: state.config.text,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadServices: () => {
      return dispatch(loadServices());
    },
    call: callTo => {
      return dispatch(call(callTo));
    },
    bindLocalStream: stream => {
      return dispatch(bindLocalStream(stream));
    },
    unBindLocalStream: () => {
      return dispatch(unBindLocalStream());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Call);






// WEBPACK FOOTER //
// ./src/containers/Call.js